import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, combineLatest, iif, of } from 'rxjs';
import { take, share, switchMap, map } from 'rxjs/operators';
import { PurchaseService, Product } from '@schoolbelle/api/purchase';
import { LoadingService } from '@schoolbelle/common/loading';
import { LedgerService, LedgerSummary } from '@schoolbelle/api/ledger';
import { GroupService, GroupExtraInfo } from '@schoolbelle/api/group';
import { PlaceOrderModalComponent } from './place-order-modal.component';
import { AddressInfo } from '@schoolbelle/api/address-input';



@Injectable({
  providedIn: 'root'
})
export class PlaceOrderModalService {

  constructor(
    private modal: BsModalService,
    private purchase:PurchaseService,
    private ledger:LedgerService,
    private group:GroupService,
    private loading:LoadingService,
  ) { }
  /**
   * 
   * @param params
   * 2020 service package product_ids are [25,26,27,28,29,30, 31,32,33,34,35,36]
   * sms product_ids are [21,22,24,17]
   */
  open(params:{
    type:'school'|'sms'|'test'|'crawl',
    product_ids:number[],
  } = {
    type:'school',
    // product_ids:[50, 51, 52, 55, 56, 57, 58],
    product_ids:[50, 51, 52, 55, 56, 61, 62, 63],
    // product_ids:[25,26,27,28,29,30, 31,32,33,34,35,36]
  }, loading_msg:string):Observable<{    
    buyer_name:string,
    payment_type: 'virtualAccount'|'bankTransfer'|'creditCard',
    items:{product_id:number, amount:number, quantity?:number}[],
    type:'school'|'sms'|'test',
    extra_data?:{
      group_name?: string,
      group_type?: 'school.kindergarten'|'school.elementary'|'school.middle'|'school.high'|'school.combined',
      // group_size?: 'xs'|'sm'|'md'|'lg'|'xl'|'xxl',
      groupAddress?:AddressInfo,
      groupName?:string,
      // group_head_name?: string,
      person_in_charge_email?: string,
      accountant_email?: string,
    },
    starts_at?:number,
    expires_at?:number,
    comment?:string,
  }> {
    const ob = this.fetchData(params).pipe(share());
    this.loading.open({busy:ob.subscribe(), message:loading_msg});
    return ob.pipe(switchMap(([products, summary, purchase_type])=>{
      const modal:BsModalRef = this.modal.show(PlaceOrderModalComponent, {class:'modal-lg', keyboard:false, initialState:{
        type:params.type,
        products, 
        summary, 
        purchase_type,
      }});
      return (<Observable<any>>modal.content.action).pipe(
        take(1)
      );
    }));    
  }  
  private fetchData (params:{
    type:'school'|'sms'|'test'|'crawl', 
    product_ids:number[]
  }):Observable<[Product[], LedgerSummary, 'renewal'|'first', GroupExtraInfo]> {
    const {type, product_ids} = params;
    return combineLatest(
      this.purchase.getProducts({product_ids}),
      iif(()=>this.group.currentGroup ? true : false, this.ledger.checkInForSummary({type}), of(null)) as Observable<LedgerSummary>,
      iif(()=>this.group.currentGroup ? true : false, this.purchase.list({type}).pipe(map(list=>list.length > 0 ? 'renewal':'first')), of('first')) as Observable<'renewal'|'first'>,
      iif(()=>this.group.currentGroup ? true : false, this.group.getExtraInfo(), of(null)) as Observable<GroupExtraInfo>,
    )
  }
}
